import { v4 as uuid } from 'uuid'

type ClearCorrelationInfo = {
  xCLEARCorrelationInfo: string
  sessionId: string
  requestId: string
} & Partial<{
  clientId: string
  deviceId: string
}>

let sessionId = ''

export const getSessionId = (): string => sessionId

export const setSessionId = (id: string): void => {
  sessionId = id ?? ''
}

let accessToken = ''

export const getAccessToken = (): string => accessToken

export const setAccessToken = (token: string): void => {
  accessToken = token ?? ''
}

export function getXCLEARCorrelationInfo(
  requestId = uuid(),
  sessionId = getSessionId()
) {
  return `[sessionId='${sessionId}'], [requestId='${requestId}'], [clientId=''], [deviceId='WEB']`
}

export function getCLEARCorrelationInfo(): ClearCorrelationInfo {
  const requestId = uuid()
  const sessionId = getSessionId()
  return {
    xCLEARCorrelationInfo: getXCLEARCorrelationInfo(requestId, sessionId),
    sessionId,
    requestId,
  }
}
